import AjaxModelV2 from '../class/AjaxModelV2';
import Single from '../class/Single';
import CDate from '../class/CDate';
import {
  Message
} from 'element-ui';
import {
  each,
  partial,
  isPlainObject,
  get
} from 'lodash';
import Config from 'config';
import store from 'src/store/index';

// 设置时间同步处理
AjaxModelV2.extend('after', 'response.syncTime', function (Response) {
  // 判断是否为xhr请求
  let date;
  if (Object.prototype.toString.call(Response) === '[object XMLHttpRequest]') {
    date = Response.getResponseHeader('date');
  } else {
    date = Response.headers.get('date');
  }
  if (date) {
    CDate.setTimeDifference(date);
  }
  return Response;
});

// 通用JSON错误检测逻辑
AjaxModelV2.extend('after', 'response.checkErrno', function (data) {
  let errno = get(data, 'errno');
  if (!errno) {
    return Promise.resolve(data.data);
  }
  if (errno === 100) {
    store.dispatch('FedLogOut');
  }
  return Promise.reject(data);
});

// 处理通用错误逻辑
let ToastFn = function (data, ignore) {
  let defaultMessage = "出错了，请稍后再试";
  Message({
    message: get(data, 'errmsg', "出错了，请稍后再试") || defaultMessage,
    type: 'error'
  });
  if (ignore === true) {
    return Promise.reject(data);
  }
  return Promise.resolve(data);
};
each([false, true], function (item) {
  AjaxModelV2.extend('after', 'catch.toast' + (item ? '' : '?'), partial(ToastFn, partial.placeholder, item));
});

export const buildFetchModel = function (config, store = null) {
  if (!('ns' in config)) {
    config.ns = Config.ns;
  }
  config.before = config.before ? config.before : ['only', 'url', 'paramsJson'];

  let after = ['response.syncTime', 'response.default', 'response.checkErrno', 'catch.toast'];
  if ('after' in config) {
    after = config.after;
  }
  config.after = after;
  if (isPlainObject(config.url)) {
    let urlConfig = config.url;
    config.url = function () {
      let url = urlConfig[get(global, '__router.app.$store.state.__GLOBAL__STATE__.USERINFO.role')];
      return url || urlConfig.default;
    }
  }
  return new Single(AjaxModelV2, config, store);
};



// WEBPACK FOOTER //
// ./src/model/model.common.js